(function () {
  // NEYL — Shop cards. The only JS responsibility here is pagination dots:
  // build one dot per "page" of the carousel, sync the active dot to the
  // scroll position, and let visitors tap a dot to jump to that page.
  // Hide the dots entirely if everything fits on one row (e.g. desktop with
  // all cards visible at once).

  function initSection(root) {
    if (root.dataset.neylScReady === '1') return;
    root.dataset.neylScReady = '1';

    var viewport = root.querySelector('[data-neyl-sc-viewport]');
    if (!viewport) return;
    var track = viewport.firstElementChild;
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    if (!cards.length) return;
    var dotsHost = root.querySelector('[data-neyl-sc-dots]');
    var prevBtn = root.querySelector('[data-neyl-sc-prev]');
    var nextBtn = root.querySelector('[data-neyl-sc-next]');

    function cardStep() {
      if (cards.length < 2) return viewport.clientWidth;
      var a = cards[0].getBoundingClientRect();
      var b = cards[1].getBoundingClientRect();
      return b.left - a.left;
    }

    function pageCount() {
      var step = cardStep();
      if (!step) return 1;
      var visible = Math.max(1, Math.round(viewport.clientWidth / step));
      return Math.max(1, cards.length - visible + 1);
    }

    function activeIndex() {
      var step = cardStep();
      if (!step) return 0;
      return Math.round(viewport.scrollLeft / step);
    }

    function buildDots() {
      if (!dotsHost) return;
      dotsHost.innerHTML = '';
      var n = pageCount();
      if (n <= 1) {
        dotsHost.style.display = 'none';
        return;
      }
      dotsHost.style.display = '';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'neyl-shop-cards__dot';
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.dataset.index = String(i);
        d.addEventListener('click', (function (idx) {
          return function () {
            viewport.scrollTo({ left: idx * cardStep(), behavior: 'smooth' });
          };
        })(i));
        dotsHost.appendChild(d);
      }
      updateDotState();
    }

    function updateDotState() {
      if (!dotsHost) return;
      var i = activeIndex();
      var dots = dotsHost.children;
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-active', k === i);
      }
    }

    function updateNavState() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var x = viewport.scrollLeft;
      // If everything fits in one view, hide both arrows.
      var hide = maxScroll <= 1;
      if (prevBtn) prevBtn.toggleAttribute('disabled', hide || x <= 1);
      if (nextBtn) nextBtn.toggleAttribute('disabled', hide || x >= maxScroll - 1);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    var rafId = null;
    viewport.addEventListener('scroll', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        updateDotState();
        updateNavState();
      });
    });

    buildDots();
    updateNavState();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots();
        updateNavState();
      }, 150);
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-neyl-shop-cards]');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
